__turbopack_context__.v({
  "count": "collections-tabs-module-scss-module__H9yxea__count",
  "label": "collections-tabs-module-scss-module__H9yxea__label",
  "root": "collections-tabs-module-scss-module__H9yxea__root",
  "tab": "collections-tabs-module-scss-module__H9yxea__tab",
  "tabActive": "collections-tabs-module-scss-module__H9yxea__tabActive",
});
